import React from "react";

export default function ClientPortalDocuments() {
  return (
    <section>
      <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#7F9BB3]">Documents</p>
      <h1 className="mt-2 text-3xl font-semibold">Your Documents</h1>
      <p className="mt-2 max-w-3xl text-slate-600">This is the dedicated client document workspace. Secure upload/download will be enabled with the DMS phase.</p>

      <div className="mt-7 rounded-2xl border bg-white p-8 shadow-sm">
        <div className="mx-auto max-w-xl text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-xl">↥</div>
          <h2 className="mt-4 text-lg font-semibold">No client documents are exposed yet</h2>
          <p className="mt-2 text-sm leading-6 text-slate-500">The portal route is active, but Firebase Storage and client-document permissions remain intentionally closed until the DMS rules are deployed. This prevents any internal file from being exposed accidentally.</p>
        </div>
      </div>
    </section>
  );
}
